import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Payment',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Payment',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Payment',
    column_type: 'datetime',
  },
  payment_account: {
    model_name: 'Payment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'payment_account',
      model_name: 'PaymentAccount',
    },
  },
  payment_account_id: {
    model_name: 'Payment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'payment_account',
      model_name: 'PaymentAccount',
    },
  },
  number: {
    model_name: 'Payment',
    column_type: 'string',
  },
  serial_number: {
    model_name: 'Payment',
    column_type: 'string',
  },
  amount: {
    model_name: 'Payment',
    column_type: 'decimal',
  },
  auditor: {
    model_name: 'Payment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'auditor',
      model_name: 'User',
    },
  },
  auditor_id: {
    model_name: 'Payment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'auditor',
      model_name: 'User',
    },
  },
  creator: {
    model_name: 'Payment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'User',
    },
  },
  creator_id: {
    model_name: 'Payment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'User',
    },
  },
  customer: {
    model_name: 'Payment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  customer_id: {
    model_name: 'Payment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'customer',
      model_name: 'Customer',
    },
  },
  kind: {
    model_name: 'Payment',
    column_type: 'enum',
  },
  state: {
    model_name: 'Payment',
    column_type: 'enum',
  },
  paid_on: {
    model_name: 'Payment',
    column_type: 'date',
  },
  image: {
    model_name: 'Payment',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  payment_allocations: {
    model_name: 'Payment',
    column_type: 'has_many',
    extra: {
      association_name: 'payment_allocations',
      model_name: 'PaymentAllocation',
      foreign_key: 'payment_id',
    },
  },
  payment_allocation_ids: {
    model_name: 'Payment',
    column_type: 'has_many',
    extra: {
      association_name: 'payment_allocations',
      model_name: 'PaymentAllocation',
      foreign_key: 'payment_id',
    },
  },
  unallocated_amount: {
    model_name: 'Payment',
    column_type: 'string',
  },
  is_even: {
    model_name: 'Payment',
    column_type: 'boolean',
  },
  can_update: {
    model_name: 'Payment',
    column_type: 'string',
  },
  can_destroy: {
    model_name: 'Payment',
    column_type: 'string',
  },
  can_approve: {
    model_name: 'Payment',
    column_type: 'string',
  },
  can_reject: {
    model_name: 'Payment',
    column_type: 'string',
  },
  can_pend: {
    model_name: 'Payment',
    column_type: 'string',
  },
  remark: {
    model_name: 'Payment',
    column_type: 'text',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
